import { useTranslation } from 'react-i18next';
import { Reveal, RevealGroup, RevealItem } from './Reveal';

const STEP_KEYS = ['step1', 'step2', 'step3'] as const;

export default function Steps() {
  const { t } = useTranslation();

  return (
    <section id="steps" className="py-24 md:py-32 bg-[#f0eee6] dark:bg-[#1a1918]">
      <div className="mx-auto max-w-6xl px-6">

        {/* Section header */}
        <Reveal className="mb-16 text-center">
          <span className="eyebrow inline-flex items-center gap-2 rounded-full border border-[#1414131a] dark:border-[#faf9f51a] px-4 py-1.5 text-[#6b6a68] dark:text-[#9a9893]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#ae5630]" />
            {t('steps.title')}
          </span>
          <h2 className="font-display display-tight mt-5 text-3xl font-medium leading-[1.1] text-[#141413] dark:text-[#faf9f5] md:text-5xl">
            {t('steps.title')}
          </h2>
        </Reveal>

        {/* Vertical timeline with offset layout */}
        <RevealGroup className="relative mx-auto max-w-3xl">
          {/* Connector line */}
          <div className="absolute left-7 top-8 bottom-8 w-px bg-gradient-to-b from-[#ae5630]/40 via-[#ae5630]/20 to-transparent hidden md:block" />

          <div className="space-y-5">
            {STEP_KEYS.map((key, i) => (
              <RevealItem key={key}>
                <div className="group flex items-start gap-6">
                  {/* Step number badge — double bezel style */}
                  <div className="shrink-0 rounded-[1rem] border border-[#1414131a] dark:border-[#faf9f51a] bg-[#1414130a] dark:bg-[#faf9f50a] p-1 shadow-warm">
                    <div className="flex h-10 w-10 items-center justify-center rounded-[calc(1rem-0.25rem)] bg-[#fffefb] dark:bg-[#1a1918] shadow-inner-glow font-mono text-base font-bold text-[#ae5630]">
                      {t(`steps.${key}.number`)}
                    </div>
                  </div>

                  {/* Content card */}
                  <div className="flex-1 min-w-0 rounded-2xl border border-[#1414131a] dark:border-[#faf9f51a] bg-[#fffefb] dark:bg-[#1a1918] shadow-warm transition-all duration-300 ease-spring group-hover:shadow-warm-lg group-hover:border-[#ae5630]/25 dark:group-hover:border-[#ae5630]/25 p-6">
                    {/* Clay accent rule */}
                    <div className={`mb-3 h-0.5 w-8 rounded-full bg-[#ae5630]/${i === 0 ? '80' : i === 1 ? '50' : '30'}`} />
                    <h3 className="font-display text-lg font-medium text-[#141413] dark:text-[#faf9f5] mb-1.5">
                      {t(`steps.${key}.title`)}
                    </h3>
                    <p className="text-sm text-[#6b6a68] dark:text-[#9a9893] leading-relaxed">
                      {t(`steps.${key}.desc`)}
                    </p>
                  </div>
                </div>
              </RevealItem>
            ))}
          </div>
        </RevealGroup>
      </div>
    </section>
  );
}
